import React, { useState, ChangeEvent } from 'react';
import { Input } from 'antd';

interface EmailInputProps {
    onChange?: (emails: string) => void;
    emails?: string;
}

const EmailInput: React.FC<EmailInputProps> = (props) => {
    const { onChange, emails } = props;
    const [emailList, setEmailList] = useState(emails || '');
    const [error, setError] = useState<string | null>(null);

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        setEmailList(e.target.value);
        setError(null);
        onChange && onChange(e.target.value); // Notify parent about the change
    };

    const handleBlur = () => {
        const emails = emailList.split(',').map((email) => email.trim());

        if (!emails.every((email) => isValidEmail(email))) {
            setError('Please enter valid email addresses.');
        }
    };

    const isValidEmail = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    return (
        <div>
            <Input
                placeholder="Enter emails separated by commas"
                value={emailList}
                onChange={handleInputChange}
                onBlur={handleBlur}
            />
            {error && <div style={{ color: 'red' }}>{error}</div>}
        </div>
    );
};

export default EmailInput;